import React, { useEffect, useState } from "react";
import laveLingeFaceDesktop from "../../../images/laveLingeFaceDesktop.png";
import laveLingeFaceMobile from "../../../images/laveLingeFaceMobile.png";
import laveLingeZoomDesktop from "../../../images/laveLingeZoomDesktop.png";
import laveLingeZoomMobile from "../../../images/laveLingeZoomMobile.png";
import elipse from "../../../images/wpro.png";
import wproLogo from "../../../images/wproLogo.png";
import { usePageContext } from "../../Context/pageContext";
import { Button } from "../../button/Button";
import { Pagination } from "../../pagination/Pagination";
import * as styles from "./Guarantee.module.scss";

export interface GuaranteeProps {}

export const Guarantee: React.FC<GuaranteeProps> = ({}) => {
  const alpha = process.env.GATSBY_DETARTRANT === "true" ? true : false;

  const [index, setIndex] = useState<number>(0);
  const max = alpha ? 980 : 1000;
  const { size } = usePageContext();
  const mobile = size?.width < max ? true : false;

  const handleClick = (index: number) => {
    setIndex(index);
    const elem = document.getElementById(`menu${index}`);
    const line = document.getElementById("yellowLine");
    if (elem && line) {
      line.style.transform = `translate(${elem.offsetLeft}px, -1px)`;
    }
  };

  useEffect(() => {
    handleClick(0);
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.geyCard}>
        <div className={styles.elipse}>
          <img src={elipse} alt="elipse" />
        </div>
        <div className={styles.logoPro}>
          <img src={wproLogo} alt="logo wpro" />
        </div>
        <div className={styles.title}>
          Prolongez la durée de vie de votre lave-linge
        </div>
        {alpha && (
          <div className={styles.menu}>
            <div className={styles.menuItems}>
              <div id="menu0" onClick={() => handleClick(0)}>
                Anticalcaire magnétique
              </div>
              <div id="menu1" onClick={() => handleClick(1)}>
                Détartrant 3 en 1
              </div>
            </div>
            <div className={styles.blackLine}>
              <div
                id="yellowLine"
                className={`${styles.yellowLine} ${
                  index === 1 ? styles.yellowRight : ""
                }`}
              />
            </div>
          </div>
        )}
        {!alpha && (
          <div>
            <div className={styles.item}>
              <div className={styles.description}>
                <div>Détartrant 3 en 1</div>
                <div>
                  3 actions en 1 pour l'entretien mensuel de votre appareil :
                  détartre, dégraisse, nettoie.
                </div>
                <div>
                  Fini les mauvaises odeurs. Un pack de 12 sachets pour toute
                  une année. Une solution simple pour un investissement durable.
                </div>
                <div className={styles.button}>
                  <Button link={process.env.GATSBY_LINK_DETA || ""}>
                    EN SAVOIR PLUS
                  </Button>
                </div>
              </div>
              <div>
                <img
                  src={mobile ? laveLingeFaceMobile : laveLingeFaceDesktop}
                  alt="lave linge de face"
                />
              </div>
            </div>
          </div>
        )}
        {alpha && (
          <div>
            <div className={styles.overflow}>
              <div
                className={`${styles.slideDiv} ${
                  index === 1 ? styles.swipe : ""
                }`}
              >
                <div className={styles.item}>
                  <div className={styles.description}>
                    <div>Anticalcaire magnétique</div>
                    <div>
                      Garanti à vie, l’anticalcaire magnétique universel WPRO
                      prévient la formation du tartre. Sous l'effet d'aimants,
                      les molécules de calcaire éclatent. Ainsi, finit le tartre
                      et vous évitez les pannes.
                    </div>
                    <div>
                      Une maxi sérénité installée en moins d'une minute. Une
                      solution simple pour un investissement durable.
                    </div>
                    <div className={styles.button}>
                      <Button link={process.env.GATSBY_LINK_CAL || ""}>
                        EN SAVOIR PLUS
                      </Button>
                    </div>
                  </div>
                  <div>
                    <img
                      src={mobile ? laveLingeZoomMobile : laveLingeZoomDesktop}
                      alt="lave linge de face"
                    />
                  </div>
                </div>
                <div className={styles.item}>
                  <div className={styles.description}>
                    <div>Détartrant 3 en 1</div>
                    <div>
                      3 actions en 1 pour l'entretien mensuel de votre appareil
                      : détartre, dégraisse, nettoie.
                    </div>
                    <div>
                      Fini les mauvaises odeurs. Un pack de 12 sachets pour
                      toute une année. Une solution simple pour un
                      investissement durable.
                    </div>
                    <div className={styles.button}>
                      <Button link={process.env.GATSBY_LINK_DETA || ""}>
                        EN SAVOIR PLUS
                      </Button>
                    </div>
                  </div>
                  <div>
                    <img
                      src={mobile ? laveLingeFaceMobile : laveLingeFaceDesktop}
                      alt="lave linge de face"
                    />
                  </div>
                </div>
              </div>
              <div className={styles.paginationWrapper}>
                <Pagination
                  nbPage={2}
                  onClick={(index) => {
                    handleClick(index);
                  }}
                  activeIndex={index}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
